/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Cli_P2Inputs */

const en_wc_tut_cli_p2 = /** @type {(inputs: Wc_Tut_Cli_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft also ships an MCP server, so AI agents such as Claude can create and edit documents with the same commands you use in the ribbon:`)
};

/**
* | output |
* | --- |
* | "WordCraft also ships an MCP server, so AI agents such as Claude can create and edit documents with the same commands you use in the ribbon:" |
*
* @param {Wc_Tut_Cli_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_cli_p2 = /** @type {((inputs?: Wc_Tut_Cli_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Cli_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_cli_p2(inputs)
});
export { wc_tut_cli_p2 as "wc.tut.cli.p2" }